
const DirectiveEntryStatusCanceled = () => {
  return (
    <p className="text-danger-soft">
      Proposta declinada
    </p>
  );
}

export default DirectiveEntryStatusCanceled;
